import { useEffect } from 'react';

import {
  type trackTileInteractionParams,
  useJobCardTracking,
} from '../../cards/job-card/use-job-card-tracking';
import { useDeckCardTyped } from '../../context';

import Styles from './peak-and-pop.style';

export type PeakAndPopType = {
  isShown: boolean;
  setIsShown: (value: boolean) => void;
  trackTileName: trackTileInteractionParams['tileName'];
  className?: string;
  children?: React.ReactNode;
};

export const PeakAndPop: React.FC<PeakAndPopType> = ({
  isShown,
  setIsShown,
  trackTileName,
  className,
  children,
}) => {
  const card = useDeckCardTyped(['TakenJob', 'AvailableJob'] as const);
  const { trackTileInteraction } = useJobCardTracking();

  useEffect(() => {
    if (isShown && card?.data?.urn && card?.data?.trackingToken) {
      trackTileInteraction({
        tileName: trackTileName,
        status: card.type,
        itemUrn: card.data.urn,
        trackingToken: card.data.trackingToken,
      });
    }
  }, [isShown]);

  return (
    <Styles.PopUpWindow isShown={isShown} hide={() => setIsShown(false)}>
      <Styles.ScrollableContent className={className}>
        {children}
      </Styles.ScrollableContent>
    </Styles.PopUpWindow>
  );
};
